import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';
import {Image} from '@learningblocks/shared-components';
import NextIcon from '@common/images/chevron-black.svg';
import style from './style.module.scss';
/**
 * SubmitButton
 *  - Next action button for Tour Component
 */
export function SubmitButton(props) {
  const className = `${style.button} ${props.className}`;
  const ALT_TEXT = 'Next Arrow';

  return (
    <Button onClick={props.onClick} className={className}>
      <span className={`${style.buttonContent} ${props.className}`}>
        {props.buttonText}
        <Image src={NextIcon} alt={ALT_TEXT} />
      </span>
    </Button>
  );
}

SubmitButton.propTypes = {
  /**
   * Callback function involked on button Click
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Shows the label for button
   */
  buttonText: PropTypes.string,
};
SubmitButton.defaultProps = {buttonText: 'Next', className: ''};
